// Configuración centralizada para manejar los valores de window.runtimeConfig
// Proporciona valores por defecto y manejo seguro de valores undefined

// Interfaz para el tipo de configuración
interface RuntimeConfig {
    MSAL_CLIENT_ID: string;
    MSAL_AUTHORITY: string;
    URL_API_SISCRED: string;
    URL_AZURE_APIM_API_SISCRED: string;
    USE_AZURE_APIM: boolean;
    USER_FAKE: string;
    APP_FECHA_VERSION: string;
    APP_VERSION: string;
    APP_NAME: string;
    OCP_APIM_KEY: string;
    APIM_CLIENT_ID: string;
}

// Declaración de tipo para window.runtimeConfig
declare global {
    interface Window {
        runtimeConfig: RuntimeConfig;
    }
}

// Función para esperar a que window.runtimeConfig esté disponible
const waitForRuntimeConfig = (): Promise<void> => {
    return new Promise((resolve) => {
        if (window.runtimeConfig) {
            resolve();
        } else {
            const checkInterval = setInterval(() => {
                if (window.runtimeConfig) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100); // Verificar cada 100ms

            // Timeout de seguridad después de 10 segundos
            setTimeout(() => {
                clearInterval(checkInterval);
                resolve();
            }, 10000);
        }
    });
};

// Función para obtener un valor de configuración de manera segura
const getConfigValue = <K extends keyof RuntimeConfig>(key: K, defaultValue: RuntimeConfig[K]): RuntimeConfig[K] => {
    return window.runtimeConfig?.[key] ?? defaultValue;
};

// Inicializar la configuración con valores por defecto
let config: RuntimeConfig = {
    MSAL_CLIENT_ID: 'empty',
    MSAL_AUTHORITY: 'empty',
    URL_API_SISCRED: '',
    URL_AZURE_APIM_API_SISCRED: '',
    USE_AZURE_APIM: false,
    USER_FAKE: 'SISCRED',
    APP_FECHA_VERSION: '',
    APP_VERSION: '',
    APP_NAME: 'SISCRED',
    OCP_APIM_KEY: '',
    APIM_CLIENT_ID: ''
};

// Función para actualizar la configuración cuando window.runtimeConfig esté disponible
const initializeConfig = async () => {
    await waitForRuntimeConfig();

    config = {
        MSAL_CLIENT_ID: getConfigValue('MSAL_CLIENT_ID', 'empty'),
        MSAL_AUTHORITY: getConfigValue('MSAL_AUTHORITY', 'empty'),
        URL_API_SISCRED: getConfigValue('URL_API_SISCRED', ''),
        URL_AZURE_APIM_API_SISCRED: getConfigValue('URL_AZURE_APIM_API_SISCRED', ''),
        USE_AZURE_APIM: getConfigValue('USE_AZURE_APIM', false),
        USER_FAKE: getConfigValue('USER_FAKE', 'SISCRED'),
        APP_FECHA_VERSION: getConfigValue('APP_FECHA_VERSION', ''),
        APP_VERSION: getConfigValue('APP_VERSION', ''),
        APP_NAME: getConfigValue('APP_NAME', 'SISCRED'),
        OCP_APIM_KEY: getConfigValue('OCP_APIM_KEY', ''),
        APIM_CLIENT_ID: getConfigValue('APIM_CLIENT_ID', '')
    };
};

// Iniciar la inicialización de la configuración
initializeConfig();

export { config };